import { render, staticRenderFns } from "./advice.vue?vue&type=template&id=a259532a&scoped=true"
import script from "./advice.vue?vue&type=script&lang=js"
export * from "./advice.vue?vue&type=script&lang=js"
import style0 from "./advice.vue?vue&type=style&index=0&id=a259532a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a259532a",
  null
  
)

export default component.exports